import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ServiceCategoryCards } from '../components/ServiceCategoryCards';
import { PersonalTrustSection } from '../components/PersonalTrustSection';
import { SocialMediaSection } from '../components/SocialMediaSection';
import { ConversionSection } from '../components/ConversionSection';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933]" data-id="element-176">
      <Navbar data-id="element-177" />
      <main data-id="element-178">
        <HeroSection data-id="element-179" />
        <ServiceCategoryCards data-id="element-180" />
        <PersonalTrustSection data-id="element-181" />
        <SocialMediaSection data-id="element-182" />
        <ConversionSection data-id="element-183" />
      </main>
      <Footer data-id="element-184" />
      <WhatsAppButton data-id="element-185" />
    </div>;
}